// Advert action types
export const START_LOADING_AD = "START_LOADING_AD";
export const FETCH_ADS = "FETCH_ADS";
export const CREATE_AD = "CREATE_AD";
export const UPDATE_AD = "UPDATE_AD";
export const DELETE_AD = "DELETE_AD";
export const END_LOADING_AD = "END_LOADING_AD";
